import { Box, Container, Divider, Flex, Grid, Group, Image, SimpleGrid, Stack, Text, Title } from "@mantine/core";
import moment from "moment";
import React, { useEffect, useState } from "react";
import VehicleNotFound from "../../../Assets/VehicleNotFound.svg";
import { useTheme } from "@emotion/react";

const DocumentPrint = ({ data = {}, dealership }, ref) => {
  const theme = useTheme();
  const [dealershipDetails, setDealershipDetails] = useState({
    dealershipName: "Carzlane Inc",
    dealershipAddress: "2747 Annapolis Rd Hanover, MD 21076",
    phone: "(240) 307-3416",
    fax: "(240) 307-3416",
    email: "sales@carzlane.com",
  });

  useEffect(() => {
    if (dealership === "Rons") {
      setDealershipDetails({
        dealershipName: "Ron's Automotive",
        dealershipAddress: "4028 Hanover Pike, Manchester, MD 21102",
        phone: "(410) 239-3180",
        fax: "(410) 239-3180",
        email: "sales@ronsautomotive.com",
      });
    }
  }, [dealership]);

  const salesPerson1FrontGross = data?.commissions?.salesPerson1?.frontGross ? parseFloat(data?.commissions?.salesPerson1?.frontGross) : 0;
  const salesPerson1BackGross = data?.commissions?.salesPerson1?.backGross ? parseFloat(data?.commissions?.salesPerson1?.backGross) : 0;

  const salesPerson2FrontGross = data?.commissions?.salesPerson2?.frontGross ? parseFloat(data?.commissions?.salesPerson2?.frontGross) : 0;
  const salesPerson2BackGross = data?.commissions?.salesPerson2?.backGross ? parseFloat(data?.commissions?.salesPerson2?.backGross) : 0;

  const salesManagerFrontGross = data?.commissions?.salesManager?.frontGross ? parseFloat(data?.commissions?.salesManager?.frontGross) : 0;
  const salesManagerBackGross = data?.commissions?.salesManager?.backGross ? parseFloat(data?.commissions?.salesManager?.backGross) : 0;

  const financeManagerFrontGross = data?.commissions?.financeManager?.frontGross
    ? parseFloat(data?.commissions?.financeManager?.frontGross)
    : 0;
  const financeManagerBackGross = data?.commissions?.financeManager?.backGross
    ? parseFloat(data?.commissions?.financeManager?.backGross)
    : 0;

  const totalOfPayments = data?.monthlyPayment ? parseFloat(data?.monthlyPayment) * parseFloat(data?.term) : 0;

  const stockNumber = data?.stockNumber ? data.VIN.slice(-6) : "";

  return (
    <Box
      style={{
        display: "none",
      }}
    >
      <Container
        size={1980}
        pos="relative"
        ref={ref}
        style={{
          ["@page "]: {
            size: "A4",
          },
        }}
      >
        <Box bg={"gray.0"} mb={"xl"}>
          <Title order={5} align="right">
            {dealershipDetails.dealershipName}
          </Title>
          <Text size="sm" align="right">
            Phone: {dealershipDetails.phone}
          </Text>
          <Text size="sm" align="right">
            {dealershipDetails.dealershipAddress}
          </Text>
        </Box>

        <Flex align={"center"} gap={"md"}>
          <Image src={data.vehicleImage || VehicleNotFound} alt="Vehicle Image" width={150} height={150} />
          <Stack spacing={0}>
            <Title order={5}>{data.vehicleTitle || "N/A"}</Title>
            <Text size="sm">
              {data.trim || "N/A"} | {data.mileage ? data.mileage + "miles" : "N/A"}
            </Text>
            <Text size="sm">{data.VIN || "N/A"}</Text>
            <Text size="sm">{stockNumber || "N/A"}</Text>
          </Stack>
        </Flex>

        <Flex w={"100%"} justify={"center"} align={"center"} bg={theme.primaryColor} p={"sm"} my={"md"}>
          <Title order={5} color="white" transform="uppercase">
            Finance Alternatives
          </Title>
        </Flex>
        <SimpleGrid cols={4}>
          <Text align="center">Cash Down</Text>
          <Text align="center">{data.terms?.[0]} month</Text>
          <Text align="center">{data.terms?.[1]} month</Text>
          <Text align="center">{data.terms?.[2]} month</Text>
          <Text align="center">${data?.downPayments?.[0] || 0}</Text>
          <Text
            align="center"
            style={{
              border: "1px solid black",
              borderColor: data?.selectedIndex?.[0] === 0 && data?.selectedIndex?.[1] === 0 ? theme.primaryColor : "transparent",
            }}
          >
            ${data.paymentPlan?.[0][0] || 0}
          </Text>
          <Text
            align="center"
            style={{
              border: "1px solid black",
              borderColor: data?.selectedIndex?.[0] === 0 && data?.selectedIndex?.[1] === 1 ? theme.primaryColor : "transparent",
            }}
          >
            ${data.paymentPlan?.[0][1] || 0}
          </Text>
          <Text
            align="center"
            style={{
              border: "1px solid black",
              borderColor: data?.selectedIndex?.[0] === 0 && data?.selectedIndex?.[1] === 2 ? theme.primaryColor : "transparent",
            }}
          >
            ${data.paymentPlan?.[0][2] || 0}
          </Text>
          <Text align="center">${data?.downPayments?.[1] || 0}</Text>
          <Text
            align="center"
            style={{
              border: "1px solid black",
              borderColor: data?.selectedIndex?.[0] === 1 && data?.selectedIndex?.[1] === 0 ? theme.primaryColor : "transparent",
            }}
          >
            ${data.paymentPlan?.[1][0] || 0}
          </Text>
          <Text
            align="center"
            style={{
              border: "1px solid black",
              borderColor: data?.selectedIndex?.[0] === 1 && data?.selectedIndex?.[1] === 1 ? theme.primaryColor : "transparent",
            }}
          >
            ${data.paymentPlan?.[1][1] || 0}
          </Text>
          <Text
            align="center"
            style={{
              border: "1px solid black",
              borderColor: data?.selectedIndex?.[0] === 1 && data?.selectedIndex?.[1] === 2 ? theme.primaryColor : "transparent",
            }}
          >
            ${data.paymentPlan?.[1][2] || 0}
          </Text>
          <Text align="center">${data?.downPayments?.[2] || 0}</Text>
          <Text
            align="center"
            style={{
              border: "1px solid black",
              borderColor: data?.selectedIndex?.[0] === 2 && data?.selectedIndex?.[1] === 0 ? theme.primaryColor : "transparent",
            }}
          >
            ${data.paymentPlan?.[2][0] || 0}
          </Text>
          <Text
            align="center"
            style={{
              border: "1px solid black",
              borderColor: data?.selectedIndex?.[0] === 2 && data?.selectedIndex?.[1] === 1 ? theme.primaryColor : "transparent",
            }}
          >
            ${data.paymentPlan?.[2][1] || 0}
          </Text>
          <Text
            align="center"
            style={{
              border: "1px solid black",
              borderColor: data?.selectedIndex?.[0] === 2 && data?.selectedIndex?.[1] === 2 ? theme.primaryColor : "transparent",
            }}
          >
            ${data.paymentPlan?.[2][2] || 0}
          </Text>
          <Text align="center">APR</Text>
          <Text align="center">{data?.APRs?.[0] || 0}%</Text>
          <Text align="center">{data?.APRs?.[1] || 0}%</Text>
          <Text align="center">{data?.APRs?.[2] || 0}%</Text>
        </SimpleGrid>
        <Flex w={"100%"} justify={"center"} align={"center"} bg={theme.primaryColor} p={"sm"} my={"md"}>
          <Title order={5} color="white" transform="uppercase">
            Vehicle Summary
          </Title>
        </Flex>
        <Box>
          <Group position="apart">
            <Text size="sm">Vehicle Retail Price</Text>
            <Text size="sm" align="right">
              ${data.vehicleRetailPrice || 0}
            </Text>
          </Group>
          <Group position="apart">
            <Text size="sm">- Trade Allowance</Text>
            <Text size="sm" align="right">
              ${data.tradeIn || 0}
            </Text>
          </Group>
          <Group position="apart">
            <Text size="sm">+ Trade Payoff</Text>
            <Text size="sm" align="right">
              ${data.tradeInPayOff || 0}
            </Text>
          </Group>
        </Box>

        <Flex gap={"xl"}>
          <Stack
            style={{
              flex: 1,
            }}
          >
            <Flex w={"100%"} justify={"center"} align={"center"} bg={theme.primaryColor} p={"sm"} my={"md"}>
              <Title order={5} color="white" transform="uppercase">
                Price Structure
              </Title>
            </Flex>
            <Group position="apart">
              <Text size="sm">Service Contract</Text>
              <Text size="sm">${data.protectionPlanPrice || 0}</Text>
            </Group>
            <Group position="apart">
              <Text size="sm">Total Tax</Text>
              <Text size="sm">${data.totalTax || 0}</Text>
            </Group>
            <Group position="apart">
              <Text size="sm">Down Payment</Text>
              <Text size="sm">${data.cashDown || 0}</Text>
            </Group>
            <Group position="apart">
              <Text size="sm">Amount Financed</Text>
              <Text size="sm">${data.amountFinanced || 0}</Text>
            </Group>
            <Group position="apart">
              <Text size="sm">Finance Charges</Text>
              <Text size="sm">${data.financeCharges || 0}</Text>
            </Group>
            <Group position="apart">
              <Text size="sm">Interest Rate</Text>
              <Text size="sm">${data.APR || 0}</Text>
            </Group>
            <Group position="apart">
              <Text size="sm">Term</Text>
              <Text size="sm">${data.term || 0}</Text>
            </Group>
          </Stack>
          <Stack
            style={{
              flex: 1,
            }}
          >
            <Flex w={"100%"} justify={"center"} align={"center"} bg={theme.primaryColor} p={"sm"} my={"md"}>
              <Title order={5} color="white" transform="uppercase">
                Purchase Fees
              </Title>
            </Flex>
            <Group position="apart">
              <Text size="sm">License Fee</Text>
              <Text size="sm">${data.licenseFee || 0}</Text>
            </Group>
            <Group position="apart">
              <Text size="sm">Registration Fee</Text>
              <Text size="sm">${data.registrationFee || 0}</Text>
            </Group>
            <Group position="apart">
              <Text size="sm">Title Fee</Text>
              <Text size="sm">${data.titleFee || 0}</Text>
            </Group>
            <Group position="apart">
              <Text size="sm">Lien Fee</Text>
              <Text size="sm">${data.lienFee || 0}</Text>
            </Group>
            <Group position="apart">
              <Text size="sm">Inspection Fee</Text>
              <Text size="sm">${data.inspectionFee || 0}</Text>
            </Group>
            <Group position="apart">
              <Text size="sm">Dealer Processing Fee</Text>
              <Text size="sm">${data.dealerProcessingFee || 0}</Text>
            </Group>
          </Stack>
        </Flex>
        <Text my={"lg"} fz={"sm"} color="dimmed">
          This presentation is designed to provide an example of various finance options that may be available. Incentive programs, Rebates,
          Terms and Payments are estimates, subject to change and are impacted by individual credit history and subject to credit approval
          and program verification. Specific details will be provided when an alternative or alternatives are selected.
        </Text>

        <SimpleGrid mt={40} cols={2} spacing={50}>
          <Stack spacing={4}>
            <Divider size={"sm"} />
            <Text transform="uppercase" fz={"sm"}>
              Signed By Dealer
            </Text>
          </Stack>
          <Stack spacing={4}>
            <Divider size={"sm"} />
            <Text transform="uppercase" fz={"sm"}>
              Signed By Client
            </Text>
          </Stack>
          <Stack spacing={4}>
            <Divider size={"sm"} />
            <Group position="apart">
              <Text transform="uppercase" fz={"sm"}>
                Sales Person
              </Text>
              <Text transform="uppercase" fz={"sm"}>
                Date
              </Text>
            </Group>
          </Stack>
          <Stack spacing={4}>
            <Divider size={"sm"} />
            <Group position="apart">
              <Text transform="uppercase" fz={"sm"}>
                Client Name
              </Text>
              <Text transform="uppercase" fz={"sm"}>
                Date
              </Text>
            </Group>
          </Stack>
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default React.forwardRef(DocumentPrint);
